import config from 'appConfig';
import { getBaseDomain } from './domain';

export const getIconUrl = (fileName: string) => `${window.location.protocol}//${getBaseDomain()}${config.baseFolder}/assets/icons/${fileName}`;

export const getImageUrl = (fileName: string) => `${window.location.protocol}//${getBaseDomain()}${config.baseFolder}/assets/images/${fileName}`;

export const getImageLink = (imageName?: string, size?: string) =>
  imageName
    ? `${window.location.protocol}//${getBaseDomain()}${config.baseFolder}/api/image/direct/${imageName}${size ? `?m=${size}` : ''}`
    : getImageUrl(config.imagePlaceholder);

const getImageDomain = () => `${getBaseDomain()}/images`

export const getStaticImageLink = (imageId: string, size?: string) =>
  imageId
    ? `${window.location.protocol}//${getImageDomain()}/${imageId}${size ? `?m=${size}` : ''}`
    : getImageUrl(config.imagePlaceholder);

export const getStyledImageSrc = (imageId: string, size?: string) => `url(${getStaticImageLink(imageId, size)})`;

export const getBackgroundImageSrc = (imageId?: string, size?: string) => ({
  backgroundImage: getStyledImageSrc(imageId, size),
});

export const getStyledIconSrc = (fileName: string) => `url(${getIconUrl(fileName)})`;



// WEBPACK FOOTER //
// ./src/services/asset.ts